// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slide-fade-enter-active[data-v-bc0c6d58]{transition:all .3s ease}.slide-fade-leave-active[data-v-bc0c6d58]{transition:all .3s ease-in}.slide-fade-enter[data-v-bc0c6d58],.slide-fade-leave-to[data-v-bc0c6d58]{transform:translateY(-10px);opacity:0}", ""]);
// Exports
module.exports = exports;
